import React, { useState } from "react";
import { Modal } from "antd";
import { Close } from "@mui/icons-material";
import { toast } from "react-toastify";
import { BeatLoader } from "react-spinners";

const DeleteModal = ({ preview, previewHandler, data, onSuccess }) => {
  const [deleteLoader, setdeleteLoader] = useState(false);
  const { http } = global.services;

  const deleteHandler = () => {
    setdeleteLoader(true);
    http
      .delete(`user-lead`, {
        id: data.id,
      })
      .finally(() => setdeleteLoader(false))
      .then(() => {
        toast.success("Lead deleted successfully");
        onSuccess(data.id);
        previewHandler();
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error ?? "Something went wrong");
      });
  };

  return (
    <Modal
      visible={preview}
      centered
      className="delete-column-modal"
      footer={null}
      onCancel={previewHandler}
      closable={false}
    >
      <button className="close-btn" onClick={previewHandler}>
        <Close />
      </button>
      <h2>Delete Lead</h2>
      <p>Are you sure you want to delete this lead?</p>
      <div className="action-box">
        <button onClick={previewHandler}>Cancel</button>
        <button className="delete" onClick={deleteHandler}>
          {deleteLoader ? <BeatLoader size={8} color="#fff" /> : "Delete"}
        </button>
      </div>
    </Modal>
  );
};

export default DeleteModal;
